import React from "react";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import { OrgUnitNavHeaderDto, useGetOrgUnitNavHeader } from "@features/ecommerce/hooks/useGetOrgUnitNavHeader";
import { telemetryProps } from "shared-ui/src/instrumentation/gtm";
import { useOrgUnitIdCurrent } from "../../../../../auth/useOrgUnitIdCurrent";
import { useClaims } from "../../../../../auth/ClaimsProvider";
import { useStorefrontSwitcher } from "../storefront-switcher/StorefrontSwitcherContext";

export function StorefrontNavHeader() {
  const { getClaimValue } = useClaims();
  const orgUnitId = useOrgUnitIdCurrent();
  const accountNameFromClaims = getClaimValue("accountName") ?? "";
  const storefrontSwitcher = useStorefrontSwitcher();

  const { data: headerDataNew } = useGetOrgUnitNavHeader(
    orgUnitId,
    Boolean(orgUnitId),
  );

  const emptyHeader: OrgUnitNavHeaderDto = {
    logoUrl: null,
    displayName: accountNameFromClaims,
    orgUnitName: null,
    orgUnitId: 0,
  };

  const headerData = headerDataNew ?? emptyHeader;
  const orgUnitName =
    headerData.orgUnitName?.trim() || headerData.displayName?.trim() || "";

  if (!orgUnitId && !storefrontSwitcher.canOpenStorefront) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, px: 2, marginTop: 2 }}>
      <Typography
        variant="body2"
        sx={{
          color: (theme) => theme.palette.text.secondary,
          fontWeight: 700,
          fontSize: "0.95rem",
          minWidth: 0,
          flex: "auto",
          fontStyle: orgUnitId ? "normal" : "italic",
        }}
        noWrap
        title={orgUnitName}
      >
        {orgUnitId ? orgUnitName : "No storefront selected"}
      </Typography>
      {!orgUnitId && storefrontSwitcher.canOpenStorefront && (
        <Button
          size="small"
          onClick={() => storefrontSwitcher.open("storefront_nametag")}
          {...telemetryProps({
            name: "storefront_switch_entry",
            section: "storefront_nametag",
            label: "Choose storefront",
          })}
        >
          Choose storefront
        </Button>
      )}
      {Boolean(orgUnitId) && storefrontSwitcher.canOpenStorefront && (
        <Tooltip title="Switch storefront">
          <IconButton
            size="small"
            aria-label="Switch storefront"
            onClick={() => storefrontSwitcher.open("storefront_nametag")}
            {...telemetryProps({
              name: "storefront_switch_entry",
              section: "storefront_nametag",
              label: "Switch storefront",
            })}
          >
            <SwapHorizIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}
